// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"video-modal-module--closeBtn--Puz-E","modalVideoContainer":"video-modal-module--modalVideoContainer--3fkwB","video":"video-modal-module--video--3aIPQ"};